import { render, staticRenderFns } from "./TvaContentSwitcher.vue?vue&type=template&id=25ca4f9e&scoped=true&"
import script from "./TvaContentSwitcher.vue?vue&type=script&lang=js&"
export * from "./TvaContentSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./TvaContentSwitcher.vue?vue&type=style&index=0&id=25ca4f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ca4f9e",
  null
  
)

export default component.exports